// extracted by mini-css-extract-plugin
export default {"container":"YmEYN1KXkfBrTa2fKo84"};